import {
	createResetGameSettingsMutation,
	GameSettingWithGame,
	ResetGameSettingsMutationParams,
	ResetGameSettingsResponse,
} from 'shared/api';
import { ConfirmModalModel, createConfirmModalModel, declareModalData } from 'shared/lib';

export type ResetGameSettingModel = ConfirmModalModel<
	GameSettingWithGame,
	ResetGameSettingsMutationParams,
	ResetGameSettingsResponse[]
>;

export const createResetGameSettingModel = () => {
	const resetGameSettingsMutation = createResetGameSettingsMutation();

	const model = createConfirmModalModel<
		GameSettingWithGame,
		ResetGameSettingsMutationParams,
		ResetGameSettingsResponse[]
	>({
		modalData: declareModalData<GameSettingWithGame>(),
		mapModalData: (setting) => ({
			gameId: setting.game.id,
			accountId: setting.account.id,
			currency: setting.currency,
		}),
		mutation: resetGameSettingsMutation,
		successMessageKey: 'reset-game-setting.success',
	});

	return model;
};
